<template>
  <el-form
    ref="loginForm"
    :model="loginForm"
    :rules="loginRules"
    class="login-form"
    auto-complete="on"
    label-position="left"
  >
    <el-form-item prop="userName">
      <el-input
        ref="userName"
        v-model="loginForm.userName"
        placeholder="请输入用户名"
        name="userName"
        type="text"
        tabindex="1"
        auto-complete="on"
        prefix-icon="el-icon-user"
        clearable=""
      />
    </el-form-item>

    <el-form-item prop="password">
      <el-input
        :key="passwordType"
        ref="password"
        v-model="loginForm.passWord"
        :type="passwordType"
        placeholder="请输入密码"
        show-password
        name="password"
        tabindex="2"
        auto-complete="on"
        @keyup.enter.native="handleLogin"
        prefix-icon="el-icon-key"
        clearable=""
      />
    </el-form-item>
    <el-button
      :loading="loading"
      type="primary"
      style="width: 100%; margin-bottom: 30px"
      @click.native.prevent="handleLogin"
      >登录</el-button
    >
  </el-form>
</template>

<script>
import HTTP_ACCOUNT from "@/api/account";
export default {
  name: "LoginByPassword",
  data() {
    return {
      loginForm: {
        userName: "",
        passWord: "",
      },
      loginRules: {
        userName: [
          { required: true, trigger: "blur", message: "请输入用户名" },
        ],
        passWord: [{ required: true, trigger: "blur", message: "请输入密码" }],
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const res = await HTTP_ACCOUNT.loginBypassword(this.loginForm);
            if (res.code === 200) {
              const { data } = res;
              localStorage.setItem("op-token", data.token);
              localStorage.setItem("op-refresh-token", data.refreshToken);
              this.$store.dispatch("user/setToken", data.token);
              this.$store.dispatch("user/setRefreshToken", data.refreshToken);
              this.$message.success("登录成功");
              setTimeout(() => {
                this.$router.push({
                  path: "/",
                });
              }, 1000);
            } else {
              this.$message.error(
                typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
              );
            }
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form {
  padding: 20px;
}
</style>
